// Toggles password-field visibility (the eye button on auth/password fields).
// Degrades gracefully: without JS the button does nothing and the field stays
// a regular password input. The button's accessible name + pressed state track
// the visual eye/eye-slash so screen readers hear the real state.
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'icon', 'button']

  toggle() {
    const revealing = this.inputTarget.type === 'password'
    this.inputTarget.type = revealing ? 'text' : 'password'
    this.iconTarget.classList.toggle('bi-eye', !revealing)
    this.iconTarget.classList.toggle('bi-eye-slash', revealing)
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-label', revealing ? 'Hide password' : 'Show password')
      this.buttonTarget.setAttribute('aria-pressed', revealing ? 'true' : 'false')
    }
  }
}
